







































import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import ExporoTooltip from '@/components/common/Tooltip.vue';

@Component({
  name: 'app-nav-bar',
  components: {
    ExporoTooltip,
  },
})
export default class AppHeader extends Vue {
  @Prop({ default: false }) showMenu: Boolean;
}

